import React, { useEffect, useState } from "react";
import BulkMailEmailGenerator from "./BulkMailEmailGenerator";
import { readUser } from "services/localStorage.service";
import { getRole } from "api/roles.api";
import TextArea from "antd/es/input/TextArea";
import TextGenerator from "components/Common/TextGenerator/TextGenerator";
import { Form } from "react-router-dom";
import { notification } from "antd";

const BulkMailMessageBox = ({ setMessage, message, setSubject, projectId, profileId, templateData, candidates }: any) => {
    console.log(profileId, "profileIdprofileId");
    const [roleData, setRoleData] = useState<any>(null);
    const [loadingText, setLoadingText] = useState<any>("");
    const [instruction, setInstruction] = useState<any>([]);
    const [streamingText, setStreamingText] = useState<any>([]);
    const [textAreaText, setTextAreaText] = useState<any>(null);

    const user = readUser();
    const getRoleDetails = () => {
        getRole(projectId)
            .then((roleDetails: any) => {
                setRoleData(roleDetails);
            })
            .catch((error: any) => {
                console.error("Error fetching role details:", error);
                // Optionally, you can display a notification or set an error state
                notification.error({
                    message: "Failed to fetch role details",
                    description: error?.message || "An unknown error occurred",
                });
            });
    };

    useEffect(() => {
        if (projectId) {
            getRoleDetails();
        }
    }, [projectId]);

    useEffect(() => {
        setTextAreaText(message);
    }, [message]);

    return (
        <div className="w-full">
            {
                candidates.map((candidate: any, index: number) =>
                    <>
                        {
                            profileId === candidate.graphProfileId &&
                            <>
                                <TextGenerator
                                    onComplete={() => {
                                        setInstruction([]);
                                    }}
                                    onChange={(text) => {
                                        setMessage(text);
                                    }}
                                    text={streamingText}
                                    newInstruction={instruction}
                                >
                                    <TextArea value={message} onChange={(e) => setMessage(e.target.value)} rows={10} placeholder="Enter your message" />
                                </TextGenerator>
                                <BulkMailEmailGenerator
                                    externalCompany={""}
                                    templateData={templateData}
                                    onLoading={(loading: any) => {
                                        if (loading) setLoadingText(loading);
                                    }}
                                    roleData={roleData}
                                    onEmailUpdate={(text: any) => {
                                        // form.setFieldValue("message", text);
                                        setMessage(text);
                                    }}
                                    onSubjectUpdate={(text: any) => {
                                        // form.setFieldValue("subject", text);
                                        setSubject(text);
                                    }}
                                    onComplete={(id: any, sub: any, body: any) => {
                                        // setRefresh(false);
                                        // onComplete(id, sub, body);
                                        setStreamingText(body);
                                        setLoadingText(false);
                                    }}
                                    profileData={user}
                                    profileId={Number(profileId)}
                                ></BulkMailEmailGenerator>
                            </>
                        }
                    </>
                )
            }
        </div>
    );
};

export default BulkMailMessageBox;